/**
 * Unified Research Compass API URL resolver.
 * Handles Public, Mine, and Collaboration Space contexts.
 */
export function resolveRcApiUrl(
  questionHashedId,
  action = "",
  routeParams = {},
) {
  let baseUrl = `/research-compass/question/${questionHashedId}/`;
  if (action) {
    baseUrl += `${action}/`;
  }

  const params = new URLSearchParams();

  if (routeParams.collaborationSpaceId) {
    params.append("collaboration_space_id", routeParams.collaborationSpaceId);
  }

  if (routeParams.viewKey) {
    params.append("view_key", routeParams.viewKey);
  }

  const queryString = params.toString();
  return queryString ? `${baseUrl}?${queryString}` : baseUrl;
}
